import { buildModal } from '../../../containers/MainWrapper/modal/ModalBuilder';
import { AllowanceModal } from './modals/AllowanceModal';
import { TransferredModal } from './modals/TransferredModal';
import HistoryModal from './modals/HistoryModal';
import {  DaysAvailableNamespace } from './types';
import { CompensatoryOffModal } from './modals/CompensatoryOffModal';

export const buildAllowanceModal =
  buildModal<undefined, DaysAvailableNamespace.AllowanceModalProps>((props, close) =>
    <AllowanceModal userId={props.userId}
      allowance={props.allowance}
      onClose={close}/> );
export const buildTransferredModal =
  buildModal<undefined, DaysAvailableNamespace.TransferredModalProps>((props, close) =>
    <TransferredModal userId={props.userId}
      transferredDays={props.transferredDays}
      onClose={close}/> );
export const buildHistoryModal =
  buildModal<undefined,DaysAvailableNamespace.HistoryModalProps>((props, close) =>
    <HistoryModal userId={props.userId} onClose={close}/> );

export const buildCompensatoryModal = 
  buildModal<undefined, DaysAvailableNamespace.CompensatoryOffModalProps>((props, close) =>
    <CompensatoryOffModal userId={props.userId} onClose={close}/>);